<div class="load-problem" [ngClass]="{'grey-color': greyColor}">
    <mat-icon>error</mat-icon>

    {{errorMessage}}

    <ng-container *ngIf="errorMessage2">
        <br/>
        {{errorMessage2}}
    </ng-container>

    <span *ngIf="link && linkTitle">
        &nbsp;<a routerLink="{{link}}">{{linkTitle}}</a>.
    </span>
</div>
